var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activity)?_c('div',[_c('span',{staticClass:"ivu-table-cell-tooltip-content"},[_c('h3',[_vm._v(" "+_vm._s(_vm.activity.label)+" ")]),_c('div',{staticClass:"body"},[_vm._v(_vm._s(_vm.activity.description))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }